<template>
  <div class="download--container">
    <button data-vs-button="download-status" v-if="!completeDownload" class="focus:outline-none"
      :class="{ 'disabled--btn-download': thereAreDocuments }" :disabled="thereAreDocuments"
      @click="checkDownloadStatus">
      <zt-icon name="box-arrow-down" />
      <span>{{ $t('message.DownloadAllDocuments.downloadAll') }}</span>
    </button>

    <zt-tooltip v-else position="right">
      <template slot="body">
        <p class="text-center">
          {{ $t('message.DownloadAllDocuments.preparingDocuments') }}
        </p>
        <p class="text-center">
          {{ $t('message.DownloadAllDocuments.sendYouMail') }}
        </p>
      </template>
      <zt-button data-vs-button="download-all" class="disabled--btn" disabled="true" color="danger" icon="pen" loader>
        {{ $t('message.DownloadAllDocuments.downloadAllDocuments') }}
      </zt-button>
    </zt-tooltip>

    <zt-modal max-width="600px" :title="titleModal" :active="active" @close="closeModal">
      <component :is="modalBody" :totalDocuments="totalDocuments" :editEmail="editEmail" :userEmail="getUserEmail"
        :completeDownload="completeDownload" :buttonDisable="buttonDisable" @close="closeModal" />
    </zt-modal>
  </div>
</template>

<script>
import Users from '@/apiClient/Users'
import DownloadAllDocuments from './modals/DownloadAllDocuments'
import DownloadAlreadyRequested from './modals/DownloadAlreadyRequested'
import DownloadCancelAndNew from './modals/DownloadCancelAndNew'

export default {
  name: 'DownloadDocuments',
  components: {
    DownloadAllDocuments,
    DownloadAlreadyRequested,
    DownloadCancelAndNew
  },
  provide() {
    return {
      closeModal: this.closeModal,
      editUserEmail: this.editUserEmail,
      setUserEmail: this.setUserEmail,
      registerDownload: this.registerDownload,
      cancelDownload: this.cancelDownload
    }
  },
  data() {
    return {
      totalDocuments: 0,
      active: false,
      userEmail: '',
      editEmail: false,
      completeDownload: false,
      downloadStatus: '',
      modalBody: '',
      titleModal: '',
      taskid: null,
      buttonDisable: false
    }
  },
  computed: {
    thereAreDocuments() {
      return !parseInt(this.totalDocuments, 10) > 0
    },
    getUserEmail() {
      return this.$store.state.user.mail
    }
  },
  async created() {
    this.userApi = new Users()
    const response = await this.userApi.getTotalDocuments()

    this.userApi
      .getDownloadAvailable()
      .then(
        responseAvailableDownload =>
          (this.completeDownload = !responseAvailableDownload.data.data.ready)
      )
      .catch(err => console.error(err))

    this.totalDocuments = parseInt(response.data.data[0].documents, 10)
    this.userEmail = this.getUserEmail
  },
  mounted() {
    if (this.$route.params.expired) {
      this.checkDownloadStatus()
    }
  },
  methods: {
    closeModal() {
      this.editEmail = false
      this.userEmail = this.$store.state.user.mail
      this.active = false
    },
    editUserEmail() {
      this.editEmail = true
    },
    setUserEmail(event) {
      this.userEmail = event.target.value
      this.editEmail = false
    },
    async registerDownload() {
      try {
        this.buttonDisable = true
        const params = {
          email: this.getUserEmail
        }
        await this.userApi.requestDownloadDocuments(params)
        this.editEmail = false
        this.completeDownload = true
        this.buttonDisable = false
      } catch (e) {
        if (e.response) {
          this.taskid = null
          if (e.response.status === 404) {
            this.active = true
            this.completeDownload = false
            this.modalBody = DownloadAllDocuments
            this.titleModal = this.$t('message.DownloadAllDocuments.downloadAllDocuments')
          }
          if (e.response.status === 400) {
            this.completeDownload = false
            this.modalBody = DownloadAlreadyRequested
            this.titleModal = this.$t('message.DownloadAllDocuments.downloadDocuments')
          }
        }
      }
    },
    async checkDownloadStatus(e) {
      if (e && e.target.disabled) {
        return
      }
      try {
        this.buttonDisable = !this.getUserEmail
        const response = await this.userApi.getTotalDocuments()
        this.totalDocuments = parseInt(response.data.data[0].documents, 10)
        const { data, status } = await this.userApi.getDownloadAvailable()
        if (status) {
          this.active = true
          this.taskid = data.data.downloadId
          this.completeDownload = false
          this.modalBody = DownloadCancelAndNew
          this.buttonDisable = false
          this.titleModal = this.$t('message.DownloadAllDocuments.downloadDocuments')
        }
      } catch (e) {
        if (e.response) {
          this.taskid = null
          this.active = true
          if (e.response.status === 404) {
            this.completeDownload = false
            this.modalBody = DownloadAllDocuments
            this.titleModal = this.$t('message.DownloadAllDocuments.downloadAllDocuments')
          }

          if (e.response.status === 400) {
            this.active = true
            this.completeDownload = false
            this.modalBody = DownloadAlreadyRequested
            this.titleModal = this.$t('message.DownloadAllDocuments.downloadDocuments')
          }
        }
      }
    },
    async cancelDownload() {
      this.buttonDisable = true
      await this.userApi.requestDownloadDocumentsReject(this.taskid)
      this.active = true
      this.taskid = null
      this.completeDownload = false
      this.modalBody = DownloadAllDocuments
      this.titleModal = this.$t('message.DownloadAllDocuments.downloadAllDocuments')
      this.buttonDisable = false
    }
  }
}
</script>
<style scoped>
.disabled--btn {
  background-color: white !important;
  border: 1px solid #e2e8f0;
  color: rgba(0, 0, 0, 0.26) !important;
}

.disabled--btn-download {
  background-color: white !important;
  color: rgba(0, 0, 0, 0.26) !important;
}

.download--container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  gap: 8px;
  height: 36px;

  /* Neutro/600 */

  border: 1px solid #707070;
  border-radius: 4px;
}

.download--container button {
  color: #707070;
}
</style>
